import { ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/assessment-overview/questionnaireAnswer'
import { PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/patient-overview/questionnaireAnswer'
import { SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/supervisory-review/questionnaireAnswer'
import { FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/final-steps/questionnaireAnswer'

// Amalgamate all section questionnaire answer type mappings
export const SUPERVISORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  ...ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
